var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"quote-tab",class:{ active: _vm.isActive },on:{"click":_vm.onTabClick}},[_vm._v(" "+_vm._s(_vm.tabName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }